//@ts-check
import { Link } from '@adobe/react-spectrum';
import React from 'react';
import { useButton } from 'react-aria';
import styled from 'styled-components';

/**
 * @typedef {object} LinkButtonProps
 * @property {Omit< import('@adobe/react-spectrum').SpectrumLinkProps, 'children' |  keyof import('@react-types/link').AriaLinkProps> } [styleProps]
 * @property {JSX.Element | string} children
 */

const NoBorderButton = styled.button`
  border: none;
  padding: 0;
  font-family: inherit;
`;

/** @param {LinkButtonProps & import('react-aria').AriaButtonOptions<"button">} props */
const LinkButton = ({ children, styleProps = {}, ...props }) => {
  /** @type {React.MutableRefObject<HTMLButtonElement | null>} */
  const buttonRef = React.useRef(null);
  const { buttonProps } = useButton(props, buttonRef);

  return (
    <Link {...styleProps}>
      <NoBorderButton {...buttonProps} ref={buttonRef}>
        {children}
      </NoBorderButton>
    </Link>
  );
};

export default LinkButton;
